import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

const MOUSE_MIDDLE_BUTTON = 2;

@Directive({ selector: '[rrMiddleClick]' })
export class MiddleClickDirective {
  @Output() rrMiddleClick = new EventEmitter();

  constructor() {}

  @HostListener('mouseup', ['$event'])
  middleclickEvent(event) {
    if (event.which === MOUSE_MIDDLE_BUTTON) {
      this.rrMiddleClick.emit(event);
    }
  }
}
